import React, { useState } from "react";
import Index from "../../../Index";
import MuiPhoneNumber from "material-ui-phone-number";
import PagesIndex from "../../../PagesIndex";
import {
  buywithcryptoAction,
} from "../../../../redux/admin/action";

import { ariaLabel } from "../addUser/UserModal.Style";

const AddCrypto = ({ getCryptoList, handelClose, updateCrypto }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // initital values declaration
  let initialValues = {
      id: updateCrypto?._id || null,
      networkName: updateCrypto?.networkName ||"",
      platformFee: updateCrypto?.platformFee ||"",
      networkAddress: updateCrypto?.networkAddress ||"",
      receiverAddress: updateCrypto?.receiverAddress ||"",
    };

  // const declaration
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);


  const handleFormSubmit = (values, { setSubmitting }) => {
      setIsButtonDisabled(true);
        buywithcryptoAction(values, adminToken).then((res) => {
          if (res?.status === 201 || 200) {
            setIsButtonDisabled(false);
            setSubmitting(false);
            getCryptoList();
            handelClose();
          } else {
            setTimeout(() => {
              setIsButtonDisabled(false);
              setSubmitting(false); 
            }, 1000); 
          }
        });
      setSubmitting(false);
  };

  return (
    <Index.Box className="episap-modal-box">
      <Index.Box className="episap-modal-header">
        <Index.Box className="edit-modal-circle-main">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex category-modal-header">
              <Index.Box className="title-main">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  {updateCrypto ? "Edit" : "Add"} Crypto Network
                </Index.Typography>
                {/* <Index.Typography variant="p" component='p' className='page-sub-title'>
                            Please fill the input blow here
                        </Index.Typography> */}
              </Index.Box>
            </Index.Box>
          </Index.Box>
          <Index.Box className="user-circle-img" onClick={handelClose}>
            <img
              src={PagesIndex.Svg.whiteclose}
              className="user-circle-img"
              alt="icon"
            />
          </Index.Box>
        </Index.Box>
      </Index.Box>
      <Index.Box className="admin-design-div login-input-design-div">
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={PagesIndex.addCryptoValidationSchema}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <Index.Stack
              component="form"
              spacing={2}
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              <Index.Box className="register-all-inputs">
                {/* <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Network Name
                  </Index.Typography>
                  <Index.TextField
                    inputProps={ariaLabel}
                    value={values?.networkName}
                    name="networkName"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        const newValue = e.target.value
                          .replace(/^\s+/, "")
                          .replace(/\s\s+/g, " ");
                        const capitalizedValue =
                          newValue?.charAt(0)?.toUpperCase() +
                          newValue.slice(1);
                        setFieldValue("networkName", capitalizedValue);
                      }
                    }}
                    helperText={touched.networkName && errors.networkName}
                    error={Boolean(errors.networkName && touched.networkName)}
                  />
                </Index.Box> */}

                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                  Platform Fee (%)
                  </Index.Typography>
                  <Index.TextField
                    inputProps={{
                      "aria-label": "Platform Fee",
                      inputMode: "decimal",
                      pattern: "^\\d{0,3}(\\.\\d{0,4})?$",
                    }}
                    type="text" 
                    value={values?.platformFee}
                    name="platformFee"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(".") || value.startsWith("00")) return;
                      if (/^\d{0,3}(\.\d{0,4})?$/.test(value)) {
                        handleChange(e); 
                      }
                    }}
                    helperText={touched.platformFee && errors.platformFee}
                    error={Boolean(errors.platformFee && touched.platformFee)}
                  />
                </Index.Box>

                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Network Address
                  </Index.Typography>
                  <Index.TextField
                    inputProps={{ ...ariaLabel, maxLength: 132 }}
                    value={values?.networkAddress}
                    name="networkAddress"
                    onChange={(e) => {
                      const newValue = e.target.value
                        .replace(/^\s+/, "")
                        .replace(/\s\s+/g, " ");
                      setFieldValue("networkAddress", newValue);
                    }}
                    onBlur={handleBlur}
                    helperText={
                      touched.networkAddress && errors.networkAddress
                    }
                    error={Boolean(
                      errors.networkAddress && touched.networkAddress
                    )}
                  />
                  {/* <span className="error-text">
                    {errors.walletAddress && errors.walletAddress}
                  </span> */}
                </Index.Box>

                <Index.Box
                  autoComplete="off"
                  className="reg-input warden-modal-box"
                >
                  <Index.Typography className="re-input-label" variant="label">
                    Receiver Address
                  </Index.Typography>
                  <Index.TextField
                   inputProps={{ ...ariaLabel, maxLength: 132 }}
                    value={values?.receiverAddress}
                    name="receiverAddress"
                    onChange={(e) => {
                      const newValue = e.target.value
                        .replace(/^\s+/, "")
                        .replace(/\s\s+/g, " ");
                      setFieldValue("receiverAddress", newValue);
                    }}
                    onBlur={handleBlur}
                    helperText={
                      touched.receiverAddress && errors.receiverAddress
                    }
                    error={Boolean(
                      errors.receiverAddress && touched.receiverAddress
                    )}
                  />
                  {/* <span className="error-text">
                    {errors.walletAddress && errors.walletAddress}
                  </span> */}
                </Index.Box>
              </Index.Box>

              <Index.Box className="modal-footer-btn pt-0">
                <Index.Button
                  variant="contained"
                  className="submit-btn"
                  type="submit"
                  disabled={isButtonDisabled || isSubmitting}
                >
                  {updateCrypto ? "UPDATE" : "SAVE"}
                  {/* {isSubmitting ? 'Submitting...' : 'Submit'} */}
                </Index.Button>
              </Index.Box>
            </Index.Stack>
          )}
        </PagesIndex.Formik>
      </Index.Box>
    </Index.Box>
  );
};

export default AddCrypto;
